export default __webpack_public_path__ + "static/media/Time.c681731e.svg";